import { ModalsProvider } from '@speeki/global-ui-components';

import {
    Country_Code,
    TenantsUserRelationship,
    UserAuthLanguage,
} from '@graphql/generated/graphql';

import { useTenantByUuid } from '@utils/hooks/useTenantByUuid';

import { AuthService } from '@services/AuthService/AuthService';
import { useSignUp } from '@services/AuthService/useSignUp';

import { useReactiveVar } from '@apollo/client';
import { currentLanguageVar, signUpFormDataVar } from '@boot/reactiveVariables';

export const useSignUpModal = () => {
    const tenantUuid = AuthService.getTenantUuid();
    const currentLanguage = useReactiveVar(currentLanguageVar);

    const { handleSignUp, signUpProcessing } = useSignUp();
    const { data } = useTenantByUuid({
        skip: !tenantUuid,
        variables: {
            uuid: tenantUuid ?? '',
        },
    });
    const tenantName = data?.tenant.name;

    const signUpData = useReactiveVar(signUpFormDataVar);

    const signUp = async () => {
        if (!signUpData) return;
        const { country, email, password, relationship } = signUpData;

        try {
            if (!tenantName || !tenantUuid)
                throw new Error('Missing data while submit SignUp form');

            await handleSignUp(
                {
                    input: {
                        country: country.value as Country_Code,
                        email,
                        language:
                            currentLanguage as unknown as UserAuthLanguage,
                        name: tenantName,
                        password,
                        relationship:
                            relationship.value as TenantsUserRelationship,
                        tenantUuid: tenantUuid,
                    },
                },
                {
                    onSuccess: () => {
                        ModalsProvider.close('TermsAndConditionsInfoModal');
                        signUpFormDataVar(null);
                    },
                },
            );
        } catch (error) {
            console.error('SignUpModal :: ', { error });
        }
    };

    return { signUp, signUpData, signUpProcessing };
};
